module.exports = __webpack_public_path__ + "static/particle-6-64ac4ade0ecbf147ee331198536d5ce2.png";